module.exports = __webpack_public_path__ + "static/media/ff_reporting.9d5a9bb8.png";